import type { ChatMessageResponseAllOfOnezeroMedia } from './chatMessageResponseAllOfOnezeroMedia';

export type ChatMessageResponseAllOfOnezero = {
  /** 미디어 정보 */
  media?: ChatMessageResponseAllOfOnezeroMedia;
};
